import module from 'finanzas/module.js'
import template from './template.html'
import moment from 'moment'

export class CargaMovimientosBancariosComponent {
  catalogos = {}
  session = undefined
  ID_Banco = undefined
  obj_CuentaBancaria = undefined
  data = undefined
  datosTabla = undefined
  subidos = true
  subiendo = false
  anios = undefined
  anio = undefined
  idLote = null
  operadoras = {}
  type = '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
  resultado = []
  archivo = undefined

  constructor($q, CargarMovimientosBancarios, CargarMovimientosBancariosCsv, $catalogos, $session, $filter, $fileSystem, $scope) {
    this.$q = $q
    this.CargarMovimientosBancariosService = CargarMovimientosBancarios
    this.CargarMovimientosBancariosCsvService = CargarMovimientosBancariosCsv
    this.$catalogosServices = $catalogos
    this.$session = $session
    this.$filter = $filter('filter')
    this.$fileSystem = $fileSystem
    this.$scope = $scope
  }

  $onInit () {
    this.anios = [moment().subtract(1, 'years').format('YYYY'), moment().format('YYYY'), moment().add(1, 'years').format('YYYY')]
    this.anio = this.anios[1]
    this.promise = this.$q.all([
      this.CargarMovimientosBancariosService.getOperadoras()
        .then((response) => (this.operadoras = response.data)),
      this.$catalogosServices.get('cuentasBancarias')
        .then((response) => (this.catalogos.cuentasBancarias = response)),
      this.$catalogosServices.get('bancos')
        .then((response) => (this.catalogos.bancos = response)),
      this.$catalogosServices.get('monedas')
        .then((response) => (this.catalogos.monedas = response)),
      this.$session.getCurrentTemporal()
        .then((response) => (this.session = response)),
    ])
  }

  filtarCuentas () {
    this.catalogos.cuentasBancarias = this.$filter(this.catalogos.cuentasBancarias, {
      ID_Cliente: this.operadora,
    })

    this.limpiarData()
  }

  generarTabla () {
    this.datosTabla = this.CargarMovimientosBancariosService.formarTabla(
      this.data,
      this.obj_CuentaBancaria,
      this.session,
      this.anio)
    this.subidos = false
  }

  subirCsv () {
    this.$fileSystem.select(false, this.type)
      .then((files) => {
        this.archivo = files[0]
        this.decodificar(this.archivo)
          .then((csvDocument) => {
            this.resultado = this.CargarMovimientosBancariosCsvService.obtenerDatos(csvDocument, this.obj_CuentaBancaria, this.session)
            this.datosTabla = this.resultado
            this.subidos = false
          }).catch((response) => {
            console.info('fallo el decodificar', response)
          })
      }).catch(() => {
        console.info('fallo el cargar el archivo')
      })
  }

  decodificar (archivo) {
    return this.$q((resolve) => {
      let reader = new global.FileReader()
      reader.onload = () => {
        let array = reader.result.split('\n')
        resolve(array)
      }
      reader.readAsText(archivo)
    })
  }

  eliminarArchivo () {
    this.archivo = undefined
    this.subidos = true
    this.datosTabla = undefined
    this.resultado = []
  }

  subirMovimientos () {
    let data = this.datosTabla.map(function (item) {
      return {
        ID_Moneda: item['ID_Moneda'],
        cargo: item['cargo'],
        abono: item['abono'],
        UID: item['UID'],
        ID_Empresa: item['ID_Empresa'],
        ID_Empleado: item['ID_Empleado'],
        fecha_operacion: item['fecha_operacion'],
        saldo: item['saldo'],
        notas: item['notas'],
        Banco: item['Banco'],
        ID_Banco: item['ID_Banco'],
        formaPago: item['formaPago'],
        cuenta: item['cuenta'],
        transaccion: item['transaccion'],
        referencia: item['referencia'],
        concepto: item['concepto'],
      }
    })

    this.subiendo = true
    return this.CargarMovimientosBancariosService.subirMovimientos(data)
      .then((data) => {
        if (data) {
          this.idLote = data.id_lote
          data.folios.forEach((item, key) => {
            this.datosTabla[key]['Folio'] = item['Folio']
          })

          this.subidos = true
        }
      }).finally(() => {
        this.subiendo = false
      })
  }

  eliminarDatosTabla () {
    this.datosTabla = undefined
  }

  limpiarData () {
    this.data = undefined
    this.datosTabla = undefined
  }

  invertir () {
    this.datosTabla.reverse()
  }
}

module.component('financesCargamovimientosbancarios', {
  controller: CargaMovimientosBancariosComponent,
  template,
})



// WEBPACK FOOTER //
// ./src/finanzas/components/cargaMovimientosBancarios/component.js